import * as React from 'react';

import ResetForm from '../containers/auth/ResetForm';


export default function(params) {
  return (
    <React.Fragment>
      <div className="log__cont log__cont--reset">
        <ResetForm code={params.code} />
      </div>
    </React.Fragment>
  );
};

